import React, { useEffect, useState } from "react";

//UI Material
import { Divider, Grid, Stack, Typography } from "@mui/material";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

//Local components
import OrdersTable from "../Components/orders-list-page/OrdersTable";
import ErrorBox from "../Components/ErrorBox";
import DataLoader from "../Components/basics/DataLoader";
import Selector from "../Components/basics/Selector";

//Constants
import { ordersStatusOptions } from "../Constants/orders";

export default function Orders() {
  // ==========>Component States<==========
  //State for storing orders data
  const [ordersList, setOrdersList] = useState([]);
  //State for setting loader for orders data
  const [isLoading, setIsLoading] = useState(true);
  //State for setting error when could not get orders data
  const [dataError, setDataError] = useState(false);
  //State for selected status for orders
  const [selectedStatus, setSelectedStatus] = useState(0);

  // ==========>Component UseEffects<==========
  //The useEffect checks for token validation
  useEffect(() => {
    getOrdersList();
    const interval = setInterval(() => {
      getOrdersList();
    }, 300000);
    return () => {
      clearInterval(interval);
    };
  }, [selectedStatus]);

  // ==========>Component Functions<==========
  //Function to get orders list
  const getOrdersList = async () => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/orders/orders-list`,
        { howMany: 5000, status: ordersStatusOptions[selectedStatus] }
      );
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setOrdersList(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setDataError(true);
    }
    setIsLoading(false);
  };

  if (isLoading) {
    return <DataLoader />;
  }

  // ==========> Component <==========
  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid container spacing={1} justifyContent="center">
      <Grid item xs={12}>
        <Typography variant="h5" fontWeight="bold">
          Órdenes de Producción
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack spacing={1} textAlign="left">
          <Typography variant="body2">
            Seleccione un estado de producción para obtener las órdenes
            registradas
          </Typography>
          <Selector
            value={selectedStatus}
            handleChange={(e) => {
              setSelectedStatus(e.target.value);
            }}
            content={ordersStatusOptions}
          />
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} align="center">
        <OrdersTable data={ordersList} getOrders={getOrdersList} />
      </Grid>
    </Grid>
  );
}
